import { OvCard, OvFormProvider, PageWrapper } from '@components'
import { useStore } from '@hooks/useStore'
import { IOVErrorResponseData, ISingleCompany } from '@typings'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { InvoiceSettingsForm } from 'src/partials/index.partials'

export const InvoiceSettingsView = observer(() => {
  const { company } = useStore()
  const navigate = useNavigate()
  const getDefaultValues = async () => {
    const _company = await company.getMyCompany().catch(() => void 0)
    return _company
  }

  const form = useForm({
    mode: 'onChange',
    defaultValues: getDefaultValues,
  })

  const handleSubmit = () => {
    form.handleSubmit(onSubmit)()
  }

  const handleFormErrors = (data: IOVErrorResponseData) => {
    const { errors } = data

    if (errors) {
      const errorKeys = Object.keys(errors)

      errorKeys.map(singleKey =>
        form.setError(singleKey as any, {
          type: 'custom',
          message: errors[singleKey][0],
        })
      )
    }
  }

  const handleSucces = (data: ISingleCompany) => {
    toast('Factuurgegevens opgeslagen', { type: 'success' })
    form.reset(data)
  }

  const onSubmit = async (values: FieldValues) => {
    try {
      const res = company.has_company ? await company.update(values) : await company.create(values)
      handleSucces(res)
    } catch (e) {
      handleFormErrors(e as IOVErrorResponseData)
    }
  }

  return (
    <PageWrapper
      pageTitle="Factuur instellingen"
      backAction={() => navigate(-1)}>
      <OvFormProvider
        form={form}
        onSubmit={handleSubmit}>
        <OvCard>
          <InvoiceSettingsForm />
        </OvCard>
      </OvFormProvider>
    </PageWrapper>
  )
})
